import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import classNames from "classnames"

const styles = theme => ({
  root: {
    width: "100%",
    cursor: "pointer",
    display: "block",
    position: "relative",
    boxSizing: "border-box",
    background: "#0B55EF",
    "&:hover": {
      "&:before": {
        content: '""',
        width: "100%",
        height: "100%",
        position: "absolute",
        left: 0,
        top: 0,
        pointerEvents: "none",
        background: "rgba(0, 0, 0, 0.16)",
      },
    },
  },

  square: {
    margin: "35px auto",
  },

  rect: {
    margin: "100px auto 50px auto",

    [theme.breakpoints.down("md")]: {
      margin: "40px auto",
    },
  },

  img: {
    display: "block",
    width: "100%",
  },
})

const Banner = ({ classes, short, style }) => {
  if (short) {
    return (
      <a
        className={classNames(classes.root, classes.square)}
        href="https://keymanletter.com/executive-list/"
        rel="noopener"
        target="_blank"
        style={style}
      >
        <picture>
          <source
            srcSet={require(`../../images/banner-keyman@3x.png`)}
            media="(max-width: 960px) and ( min-width: 600px)"
          />
          <img
            className={classes.img}
            srcSet={require(`../../images/banner-keyman-2@3x.png`)}
            alt="banner"
          />
        </picture>
      </a>
    )
  } else {
    return (
      <a
        className={classNames(classes.root, classes.rect)}
        href="https://keymanletter.com/executive-list/"
        rel="noopener"
        target="_blank"
        style={style}
      >
        <picture>
          <source
            srcSet={require(`../../images/banner-keyman-2@3x.png`)}
            media="(max-width: 500px)"
          />
          <source
            srcSet={require(`../../images/banner-keyman@3x.png`)}
            media="(min-width: 600px)"
          />
          <img
            className={classes.img}
            srcSet={require(`../../images/banner-keyman@3x.png`)}
            alt="banner"
          />
        </picture>
      </a>
    )
  }
}

Banner.propTypes = {
  classes: PropTypes.object.isRequired,
  short: PropTypes.bool,
}

export default withStyles(styles)(Banner)
